export const SHOOT_TYPE_INDIVIDUAL = "individual";
export const SHOOT_TYPE_PHOTOSHOOT = "photoshoot";
